"use client";
import React, { useEffect, useRef, useState } from "react";

import { useModalCustomerContext } from "@/context/CustomerContext";
import { useKfStore } from "@/lib/store/customer";
import { Avatar, Button, Input } from "antd";
import { RingLoader } from "react-spinners";
import { useTranslations } from "next-intl";
import { CloseCircleTwoTone, SendOutlined } from "@ant-design/icons";
const Robot = ({ content }: { content: string }) => {
	return (
		<div className="flex  w-full !items-start px-4 py-2">
			<div className="flex flex-shrink-0 items-center">
				<img src="/image/logo.png" className="w-[40px]" />
			</div>
			<div className="ignore ml-2 rounded-[5px] bg-white px-2 py-1 !text-black shadow">{content}</div>
		</div>
	);
};

const Me = ({ content }: { content: string }) => {
	return (
		<div className="flex !items-start justify-end px-4 py-2">
			<div className="ignore mr-2 rounded-[5px] bg-main px-2 py-1 !text-white shadow">{content}</div>
		</div>
	);
};

const SaveEmail = ({ setShowSaveEmail }: { setShowSaveEmail: (show: boolean) => void }) => {
	const t = useTranslations();
	const { setEmail } = useKfStore();
	const [value, setValue] = useState("");
	const [errMsg, setErrMsg] = useState("");

	// 校验邮箱格式
	const formatEmail = (email: string) => {
		const reg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/;
		return reg.test(email);
	};

	useEffect(() => {
		setErrMsg(!formatEmail(value) ? t("base.vailEmailTip") : "");
	}, [value]);
	return (
		<div className="c-flex my-20 flex-col ">
			<h3 className="text-center text-2xl font-bold text-main">{t("base.contactYou")}</h3>
			<div className="mx-12 my-4 text-center text-gray-500">{t("base.ContactYouContent")}</div>
			<div className="container my-2">
				<input
					type="email"
					name="email"
					value={value}
					onChange={(e) => setValue(e.target.value)}
					id="email"
					className="block w-full rounded-md border-0 py-1.5 pl-2 text-gray-900 shadow-sm ring-1 ring-inset placeholder:text-gray-400 focus-visible:outline-0 sm:text-sm sm:leading-6"
					placeholder="you@example.com"
					aria-describedby="email-description"
				/>
				<p className="text-sm text-red-700">{errMsg}</p>
			</div>
			<div className="container">
				<Button
					className=" my-2 w-full cursor-pointer !rounded-sm  !bg-main !bg-gradient-to-r !from-blue-500 !to-indigo-600 !text-white"
					onClick={() => {
						if (value && formatEmail(value)) {
							setEmail(value);
							setShowSaveEmail(false);
						}
					}}
				>
					{t("base.Save")}
				</Button>
			</div>
		</div>
	);
};
const ModalCustomer = () => {
	const t = useTranslations();

	const { isCustomerModalOpen, closeModalCustomer } = useModalCustomerContext();
	const { email, sendMessage, getChatToken } = useKfStore();
	const inputRef = useRef(null);
	const chatRef = useRef(null);
	const [showSaveEmail, setShowSaveEmail] = useState<boolean>(false);
	const [chatMsg, setChatMsg] = useState<
		{
			type: "robot" | "me";
			msg: string;
			date: Date;
		}[]
	>([
		{
			type: "robot",
			msg: "Hello! What do you need help with?",
			date: new Date(),
		},
	]);
	const [loading, setLoading] = useState<boolean>(false);
	useEffect(() => {
		getChatToken();
	}, []);
	useEffect(() => {
		if (isCustomerModalOpen) {
			inputRef.current?.focus();
		}
		// setShowSaveEmail(!email);
		// 注释该行代码，因为不想让打开客服窗口时自动弹出保存邮箱的弹窗

		// setOverflow(open ? "hidden" : "auto");
		document.documentElement.style.overflow = isCustomerModalOpen ? "hidden" : "auto";
	}, [isCustomerModalOpen]);

	const handleSetChatMsg = (type: "robot" | "me", msg: string) => {
		// @ts-ignore
		setChatMsg((old) => {
			const value = JSON.parse(JSON.stringify(old));
			// @ts-ignore
			value.push({
				type: type,
				msg: msg,
				date: new Date(),
			});
			return value;
		});
	};

	const handleSend = async () => {
		const msg = inputRef.current?.value;
		if (msg) {
			inputRef.current.value = "";
			handleSetChatMsg("me", msg);
			const result = await sendMessage(msg, setLoading);
			if (result) {
				handleSetChatMsg("robot", result);
			} else {
				handleSetChatMsg("robot", "Error");
			}
		}
	};

	useEffect(() => {
		chatRef.current?.scrollTo({ top: chatRef.current.scrollHeight });
	}, [chatMsg]);

	return (
		<div
			className={` bottom-14 z-50 md:bottom-5 md:right-5 ${
				isCustomerModalOpen ? "fixed" : "hidden"
			} animate__animated animate__fadeInUp `}
		>
			<div>{isCustomerModalOpen}</div>
			<div className="font-poppins overflow-hidden rounded-[10px] border bg-white shadow md:h-[530px] md:w-[400px]">
				<div className="flex h-[70px] items-center justify-between bg-[url('/image/gb.png')] to-indigo-600 p-4 px-4 font-bold text-white ">
					<span className="text-lg">{t("base.customerAssistant")}</span>
					<div onClick={closeModalCustomer} className="cursor-pointer ">
						<i className="ri-close-line  text-[30px] !text-white"></i>
					</div>
				</div>
				<style>
					{`
.online-chat::-webkit-scrollbar {
    width: 5px;
}

.online-chat::-webkit-scrollbar-track {
    background: transparent !important;
}

.online-chat::-webkit-scrollbar-thumb {
    background: #bbbbbb;
    border-radius: 10px;
}

          `}
				</style>
				<div className="online-chat h-[390px] overflow-y-auto overflow-x-hidden" ref={chatRef}>
					{showSaveEmail ? (
						<SaveEmail setShowSaveEmail={setShowSaveEmail} />
					) : (
						<>
							{chatMsg.map((item, index) => {
								if (item.type === "robot") {
									return <Robot content={item.msg} key={index} />;
								} else {
									return <Me content={item.msg} key={index} />;
								}
							})}
						</>
					)}
				</div>
				{!showSaveEmail && (
					<div className="flex items-center justify-between border-t">
						<input
							type="text"
							className="!h-[60px] flex-1 !border-none !text-[18px] !text-black  focus:!outline-none focus:!ring-0"
							placeholder="Please enter your question"
							ref={inputRef}
							onKeyDown={(e) => {
								if (e.key === "Enter") {
									handleSend();
								}
							}}
						/>
						{loading ? (
							<RingLoader className="mr-2 !text-black" size={20} />
						) : (
							<div onClick={handleSend}>
								<SendOutlined className="mr-2  cursor-pointer text-xl !font-bold !text-black " />
							</div>
						)}
					</div>
				)}
			</div>
		</div>
	);
};

export default ModalCustomer;
